import Marquee from "react-fast-marquee";
import { Droplets } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

export default function EditorialMarquee() {
  const { marquee: phrase } = useSiteContent();
  return (
    <section data-testid="editorial-marquee" className="py-16 border-y border-slate-800/60 bg-navy overflow-hidden">
      <Marquee speed={40} gradient={false}>
        {[0, 1, 2].map((rep) =>
          phrase.map((text, i) => (
            <span key={`${rep}-${i}`} className="flex items-center gap-8 mx-8">
              <span className="font-bebas text-6xl md:text-8xl text-outline whitespace-nowrap tracking-wide">
                {text}
              </span>
              <Droplets className="w-8 h-8 text-electric shrink-0" />
            </span>
          ))
        )}
      </Marquee>
    </section>
  );
}
